export class DropParticipantResponse {

    "patientId":Number;
    "userId":Number;
    "remarks":String;
    
 }